import { z } from 'zod'
import { validateWithZodSchema } from '../../core/utils/utilities.ts'

/**
 * Lean row returned by the `/accounts/mobile-list` endpoint (the mobile companies browse
 * list). Only what a mobile row renders: id, name, and the investment-stats headline
 * numbers — the backend `view__accounts_mobile_list` RPC deliberately omits the ~50
 * columns / embedded arrays of the full account record. `.passthrough()` keeps it
 * tolerant of extra stat keys; the stats object itself is passed through unmodelled
 * (RecordRow reads `invested_fmt` / `realized_value_fmt` / `unrealized_value_fmt` /
 * `moic_fmt`).
 */
export const AccountMobileListRecordSchema = z
  .object({
    accounts__id: z.string(),
    accounts__name: z.string().nullish(),
    prog__investment_stats: z.record(z.string(), z.unknown()).nullish()
  })
  .passthrough()

export type AccountMobileListRecord = z.infer<typeof AccountMobileListRecordSchema>

export function validateAccountMobileListRecord(
  data: unknown,
  options?: { isArray?: boolean }
): AccountMobileListRecord | AccountMobileListRecord[] {
  return validateWithZodSchema(AccountMobileListRecordSchema, data, 'account mobile list record', options) as
    | AccountMobileListRecord
    | AccountMobileListRecord[]
}
